module.exports = __webpack_public_path__ + "img/tips.ca7c8153.png";